import React from 'react';
import { ActivityIndicator, StyleSheet, View } from 'react-native';
import { TestIDs } from 'src/constants/testIDs.constants';

export const Loader = () => (
  <View style={[styles.container, styles.horizontal]} testID={TestIDs.LOADER}>
    <ActivityIndicator size="large" color="#EB5E0B" />
  </View>
);

const styles = StyleSheet.create({
  container: {
    flex: 1,
    justifyContent: 'center',
  },
  horizontal: {
    flexDirection: 'row',
    justifyContent: 'space-around',
    padding: 10,
  },
});
